<!-- BRED-CRUMB -->
<div class="wrapper" style="padding: 55px 0">
  <section class="profile_listing_section master_dashboard_sec">
    <!-- <div class="overlay-heading">
      <h1>My Profile</h1>
    </div> -->
    <div class="profile_row" fxLayout="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch">
      <div class="profile_left_column" fxLayout="column" fxFlex="19" fxFlex.lg="24" fxFlex.md="24" fxFlex.sm="35"
        fxFlex.xs="100" fxFlexFill>
        <section></section>

        <div class="profile_listing">
          <!--<h4 class="my_profile_heading">My Account</h4>-->
          <div class="master_feed_sec">
            <div class="feed_user_details">
              <div class="userInfoFlex">

            <div class="user_img">
            
              <!-- PROFESSIONAL -->
              <img
                *ngIf="loginData?.type === 'PROFESSIONAL' && (userProfileData?.profile_image?.url || loginDetails?.profile_image?.url)"
                [src]="userProfileData?.profile_image?.url || loginDetails?.profile_image?.url" alt="" />
            
              <!-- SUPPLIER / PRACTICE -->
              <img *ngIf="(loginData?.type === 'SUPPLIER' || loginData?.type === 'PRACTICE')
                       && (userProfileData?.logo?.url || loginDetails?.logo?.url)"
                [src]="userProfileData?.logo?.url || loginDetails?.logo?.url" alt="" />
            
              <!-- ADMIN -->
              <img *ngIf="loginData?.type === 'ADMIN'" src="../../../../../assets/images/logo.svg" alt="Admin Icon" />
            
              <!-- DEFAULT (only if none of the above match) -->
              <img *ngIf="!(loginData?.type === 'PROFESSIONAL' && (userProfileData?.profile_image?.url || loginDetails?.profile_image?.url))
                       && !((loginData?.type === 'SUPPLIER' || loginData?.type === 'PRACTICE') && (userProfileData?.logo?.url || loginDetails?.logo?.url))
                       && loginData?.type !== 'ADMIN'" src="../../../../../assets/images/user-placeholder-img.svg"
                alt="User Placeholder" />
            
            </div>


               <div class="userName">
                  <p>Welcome Back!</p>
                  <h4 *ngIf="['PROFESSIONAL'].includes(loginData?.type)">
                    {{ userProfileData?.name || loginDetails.name  }}
                  </h4>
                  <h4 *ngIf="['SUPPLIER', 'PRACTICE'].includes(loginData?.type)">
                      {{userProfileData?.business_name || loginDetails.business_name}}
                    <!-- {{ directory?.company_name }} -->
                  </h4>
                  <h4 *ngIf="['ADMIN'].includes(loginData?.type)">Admin</h4>
                </div>
              </div>
              <div class="user_content">
                <div class="flex_followers">
                  <div class="form-group" (click)="followIngPopup()">
                    <label for="" class="custom-label">Following</label>
                    <p class="value">{{ countOfFollowing }}</p>
                  </div>
                  <div class="form-group" (click)="followersPopup()">
                    <label for="" class="custom-label">Followers</label>
                    <p class="value">{{ countOfFollowers }}</p>
                  </div>
                </div>
                <!--<button class=" btn btn-sm global-btn view_profile_btn" [routerLink]="['/profile/directory']"
                mat-button>My Directory
                Profile</button>-->
              </div>
            </div>
          </div>
          <div class="profile_web_menu">
            <h4 class="my_profile_heading-n">Account info</h4>

            <!-- 'PROFESSIONAL' menu-->

            <ul class="profile_list_ul" *ngIf="['PROFESSIONAL'].includes(loginData?.type)">
              <ng-container *ngFor="let item of menuItems">
                <li>
                  <!-- Normal Link -->
                  <a *ngIf="!item.children && item.route" (click)="handleMenuClick(item)"
                    [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </a>

                  <!-- Dropdown Menu -->
                  <ng-container *ngIf="item.children">
                    <a (click)="handleAction(item.action)">
                      <div *ngIf="item.icon" class="icon-stack">
                        <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
                        <mat-icon class="inner-icon">work</mat-icon>
                      </div>
                      <span>{{ item.label }}</span>
                      <mat-icon style="margin-left: auto;">
                        {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </a>

                    <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
                      <li *ngFor="let child of item.children">
                        <a *ngIf="!child.children" (click)="handleMenuClick(child)"
                          [class.router-active]="isLinkActive(child.route)" [class]="child.class || ''">
                          <span class="span">{{ child.label }}</span>
                        </a>

                        <!-- Nested Dropdown -->
                        <ng-container *ngIf="child.children">
                          <a (click)="handleAction(child.action)">
                            <span class="span">{{ child.label }}</span>
                            <mat-icon style="margin-left: auto;">
                              {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                          </a>
                          <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
                            <li *ngFor="let sub of child.children">
                              <a (click)="handleMenuClick(sub)" [class.router-active]="isLinkActive(sub.route)"
                                [class]="sub.class || ''">
                                <span class="span">{{ sub.label }}</span>
                              </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>

              <!-- Logout -->
              <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul>


            <!-- <ul class="profile_list_ul" *ngIf="['PROFESSIONAL'].includes(loginData?.type)">
              <ng-container *ngFor="let item of menuItems">
                <li>
                
                  <a *ngIf="!item.children && item.route" (click)="handleMenuClick(item)"
                    [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </a>



            
                  <ng-container *ngIf="item.children">
                    <a (click)="handleAction(item.action)">
                      <div *ngIf="item.icon" class="icon-stack">
                        <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
                        <mat-icon class="inner-icon">work</mat-icon>
                      </div>
                      <span>{{ item.label }}</span>
                      <mat-icon style="margin-left: auto;">
                        {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </a>

                    <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
                      <li *ngFor="let child of item.children">
                        <a *ngIf="!child.children" (click)="handleMenuClick(child)"
                          [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''">
                          <span class="span">{{ child.label }}</span>
                        </a>

             
                        <ng-container *ngIf="child.children">
                          <a (click)="handleAction(child.action)">
                            <span class="span">{{ child.label }}</span>
                            <mat-icon style="margin-left: auto;">
                              {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                          </a>
                          <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
                            <li *ngFor="let sub of child.children">
                              <a (click)="handleMenuClick(sub)" [class.router-active]="isLinkActive(item.route)"
                                [class]="item.class || ''">
                                <span class="span">{{ sub.label }}</span>
                              </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>
     
              <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul> -->
            <!-- 'PROFESSIONAL' menu end-->
            <!--SUPPLIER menu start-->



            <ul class="profile_list_ul" *ngIf="['SUPPLIER'].includes(loginData?.type)">
              <ng-container *ngFor="let item of supplierMenuItems">
                <li>
                  <!-- Route item -->
                  <a *ngIf="!item.children && item.route" (click)="handleMenuClick(item)"
                    [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </a>

                  <!-- Dropdown parent -->
                  <ng-container *ngIf="item.children">
                    <a (click)="handleAction(item.action)">
                      <div *ngIf="item.icon" class="icon-stack">
                        <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
                        <mat-icon class="inner-icon">work</mat-icon>
                      </div>
                      <span>{{ item.label }}</span>
                      <mat-icon style="margin-left: auto;">
                        {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </a>

                    <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
                      <li *ngFor="let child of item.children">
                        <!-- Leaf -->
                        <a *ngIf="!child.children && child.route" (click)="handleMenuClick(child)"
                          [class.router-active]="isLinkActive(child.route)" [class]="child.class || ''">
                          <span class="span">{{ child.label }}</span>
                        </a>

                        <!-- Nested dropdown -->
                        <ng-container *ngIf="child.children">
                          <a (click)="handleAction(child.action)">
                            <span class="span">{{ child.label }}</span>
                            <mat-icon style="margin-left: auto;">
                              {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                          </a>

                          <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
                            <li *ngFor="let sub of child.children">
                              <a *ngIf="sub.route" (click)="handleMenuClick(sub)"
                                [class.router-active]="isLinkActive(sub.route)" [class]="sub.class || ''">
                                <span class="span">{{ sub.label }}</span>
                              </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>

              <!-- Logout -->
              <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon>
                  <span>Logout</span>
                </a>
              </li>
            </ul>




            <!-- <ul class="profile_list_ul" *ngIf="['SUPPLIER'].includes(loginData?.type)">
               <ng-container *ngFor="let item of supplierMenuItems">
  <li>
>
    <a *ngIf="!item.children && item.route"
       (click)="handleMenuClick(item)"
            [class.router-active]="isLinkActive(item.route)"
   [class]="item.class || ''"
       >
      <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </a>

 
    <ng-container *ngIf="item.children">
      <a (click)="handleAction(item.action)">
        <div *ngIf="item.icon" class="icon-stack">
          <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
          <mat-icon class="inner-icon">work</mat-icon>
        </div>
        <span>{{ item.label }}</span>
        <mat-icon style="margin-left: auto;">
          {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </a>

      <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
        <li *ngFor="let child of item.children">
         
          <a *ngIf="!child.children"
             (click)="handleMenuClick(child)"
                  [class.router-active]="isLinkActive(item.route)"
   [class]="item.class || ''"
             >
            <span class="span">{{ child.label }}</span>
          </a>

  
          <ng-container *ngIf="child.children">
            <a (click)="handleAction(child.action)">
              <span class="span">{{ child.label }}</span>
              <mat-icon style="margin-left: auto;">
                {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </a>

            <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
              <li *ngFor="let sub of child.children">
                <a (click)="handleMenuClick(sub)"       [class.router-active]="isLinkActive(item.route)"
   [class]="item.class || ''">
                  <span class="span">{{ sub.label }}</span>
                </a>
              </li>
            </ul>
          </ng-container>
        </li>
      </ul>
    </ng-container>
  </li>
</ng-container>

         
            <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul> -->
            <!--SUPPLIER menu end-->
            <!--PRACTICE menu start-->

            <ul class="profile_list_ul" *ngIf="['PRACTICE'].includes(loginData?.type)">
              <ng-container *ngFor="let item of practiceMenuItems">
                <li>

                  <a *ngIf="!item.children && item.route" (click)="handleMenuClick(item)"
                    [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''"
                    [routerLinkActiveOptions]="{ exact: item.exact }">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </a>

                  <ng-container *ngIf="item.children">
                    <a (click)="handleAction(item.action)">
                      <div *ngIf="item.icon" class="icon-stack">
                        <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
                        <mat-icon class="inner-icon">work</mat-icon>
                      </div>
                      <span>{{ item.label }}</span>
                      <mat-icon style="margin-left: auto;">
                        {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </a>

                    <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
                      <li *ngFor="let child of item.children">

                        <!-- Fix here: Use child.route, not item.route -->
                        <a *ngIf="!child.children" (click)="handleMenuClick(child)"
                          [class.router-active]="isLinkActive(child.route)" [class]="child.class || ''">
                          <span class="span">{{ child.label }}</span>
                        </a>

                        <ng-container *ngIf="child.children">
                          <a (click)="handleAction(child.action)">
                            <span class="span">{{ child.label }}</span>
                            <mat-icon style="margin-left: auto;">
                              {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                          </a>
                          <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
                            <li *ngFor="let sub of child.children">

                              <!-- Fix here: Use sub.route, not item.route -->
                              <a (click)="handleMenuClick(sub)" [class.router-active]="isLinkActive(sub.route)"
                                [class]="sub.class || ''">
                                <span class="span">{{ sub.label }}</span>
                              </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>

              <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul>


            <!-- <ul class="profile_list_ul" *ngIf="['PRACTICE'].includes(loginData?.type)">
              <ng-container *ngFor="let item of practiceMenuItems">
                <li>
                 
                  <a *ngIf="!item.children && item.route" (click)="handleMenuClick(item)"
                    [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''"
                    [routerLinkActiveOptions]="{ exact: item.exact }">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </a>



                  <ng-container *ngIf="item.children">
                    <a (click)="handleAction(item.action)">
                      <div *ngIf="item.icon" class="icon-stack">
                        <mat-icon class="outer-icon">{{ item.icon }}</mat-icon>
                        <mat-icon class="inner-icon">work</mat-icon>
                      </div>
                      <span>{{ item.label }}</span>
                      <mat-icon style="margin-left: auto;">
                        {{ isDropdownOpen(item.action) ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </a>

                    <ul *ngIf="isDropdownOpen(item.action)" style="margin-left: 50px;">
                      <li *ngFor="let child of item.children">
                 
                        <a *ngIf="!child.children" (click)="handleMenuClick(child)"
                          [class.router-active]="isLinkActive(item.route)" [class]="item.class || ''">
                          <span class="span">{{ child.label }}</span>
                        </a>

                    
                        <ng-container *ngIf="child.children">
                          <a (click)="handleAction(child.action)">
                            <span class="span">{{ child.label }}</span>
                            <mat-icon style="margin-left: auto;">
                              {{ isDropdownOpen(child.action) ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                          </a>
                          <ul *ngIf="isDropdownOpen(child.action)" style="margin-left: 20px;">
                            <li *ngFor="let sub of child.children">
                              <a (click)="handleMenuClick(sub)" [class.router-active]="isLinkActive(item.route)"
                                [class]="item.class || ''">
                                <span class="span">{{ sub.label }}</span>
                              </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>
          
              <li>
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul> -->
            <!--PRACTICE menu end-->
            <!--Admin menu start-->
            <ul class="profile_list_ul" *ngIf="['ADMIN'].includes(loginData?.type)">
              <!-- My Dashboard -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/my-dashboard']"
                  routerLinkActive="router-active">
                  <mat-icon>dashboard</mat-icon><span>My Dashboard</span>
                </a>
              </li> -->

              <!-- My favourites -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/favourites']"
                  routerLinkActive="router-active">
                  <mat-icon>favorite</mat-icon><span>My Favourites</span>
                </a>
              </li> -->
              <!-- My Address -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/address']"
                  routerLinkActive="router-active">
                  <mat-icon> pin_drop</mat-icon><span>My Address</span>
                </a>
              </li> -->
              <li>
                <a (click)="toggleSubMenu(true)">
                  <mat-icon>newspaper</mat-icon>
                  <span>News Feed</span>
                  <mat-icon *ngIf="isSubMenuOpen" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isSubMenuOpen" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isSubMenuOpen" class="">
                  <li>
                    <a [routerLink]="['/profile/my-dashboard']" routerLinkActive="router-active">
                      <!-- <mat-icon>newspaper</mat-icon> -->
                      <span class="span">News Feed</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/profile/list-newsfeeds']" routerLinkActive="router-active">
                      <!-- <mat-icon>category</mat-icon> -->
                      <span class="span">News Feed Category</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/detail']"
                  [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="router-active">
                  <mat-icon>account_circle</mat-icon>
                  <span>View Profile</span>
                </a>
              </li>
              <!-- catalogues -->
              <!-- ...existing code... -->
              <li>
                <a (click)="toggleCatalogueMenu()">
                  <mat-icon>library_books</mat-icon>
                  <span>Catalogues</span>
                  <mat-icon *ngIf="isCatalogueMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isCatalogueMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isCatalogueMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/catalogues']" class="noIconMenu"
                      routerLinkActive="router-active">
                      <span>Catalogue</span>
                    </a>
                  </li>

                  <li>
                    <a [ngClass]="{'router-active': router.url.startsWith('/profile/catalogue-categories') &&!router.url.includes('/list-category') &&
                                    !router.url.includes('/add-category') &&   !router.url.includes('/edit-category') }"
                      (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/catalogue-categories']"
                      class="noIconMenu">
                      <span>Catalogue Type</span>
                    </a>
                  </li>

                  <li>
                    <a [ngClass]="{ 'router-active': router.url.includes('/list-category') ||  router.url.includes('/add-category') ||
                                  router.url.includes('/edit-category')}" (click)="toggleJobsDropdownClose()"
                      [routerLink]="['/profile/catalogue-categories/list-category']" class="noIconMenu">
                      <span>Catalogue Categories</span>
                    </a>
                  </li>


                  <!-- You can add more submenu items here if needed -->
                </ul>
              </li>



              <!-- Learning hub -->

              <li>
                <a (click)="toggleLearingHubMenu()">
                  <mat-icon>grading</mat-icon>
                  <span>Learning hub</span>
                  <mat-icon *ngIf="isLearningHubMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isLearningHubMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isLearningHubMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" routerLinkActive="router-active"
                      [routerLink]="['/profile/course-listing']" class="noIconMenu">
                      <span>Course listing</span>
                    </a>
                  </li>

                  <li>
                    <a [ngClass]="{ 'router-active': router.url.includes('/list-course-type') ||  router.url.includes('/add-course-type') ||
                                  router.url.includes('/edit-type')}" (click)="toggleJobsDropdownClose()"
                      [routerLink]="['/profile/course-categories/list-course-type']" class="noIconMenu">
                      <span>Course Type</span>
                    </a>
                  </li>

                  <li>
                    <a [ngClass]="{'router-active': router.url.startsWith('/profile/course-categories') &&!router.url.includes('/list-course-type') &&
                                    !router.url.includes('/add-course-type') &&   !router.url.includes('/edit-type') }"
                      (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/course-categories']"
                      class="noIconMenu">
                      <span>Course Categories</span>
                    </a>
                  </li>


                  <li>
                    <a (click)="toggleJobsDropdownClose()" routerLinkActive="router-active"
                      [routerLink]="['/profile/registered-course']" class="noIconMenu">
                      <span>My LearningHub</span>
                    </a>
                  </li>




                  <!-- You can add more submenu items here if needed -->
                </ul>
              </li>





              <!-- ...remove the old single "Catalogues" li from the list... -->
              <!-- My supplies -->
              <li *ngIf="['ADMIN', 'SUPPLIER'].includes(loginData?.type)">
                <a (click)="toggleSuppliesMenu()">
                  <mat-icon>how_to_vote</mat-icon>
                  <span>Supplies</span>
                  <mat-icon *ngIf="isSuppliesMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isSuppliesMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isSuppliesMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/supplies']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>how_to_vote</mat-icon> -->
                      <span class="span">My Supplies</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/supply-categories']"
                      routerLinkActive="router-active">
                      <span class="span">Supply category</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/favourites']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>favorite</mat-icon> -->
                      <span class="span">My Favourites</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/orders']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>shopping_cart</mat-icon> -->
                      <span class="span">Orders</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="[
                        '/profile/dental-supplier-supply-settings'
                      ]" routerLinkActive="router-active">
                      <!-- <mat-icon>settings</mat-icon> -->
                      <span class="span">Supply Settings</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/account-pay']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>account_balance_wallet</mat-icon> -->
                      <span class="span">Account Pay</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/supply-sub-categories']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>device_hub</mat-icon> -->
                      <span class="span">Supply sub categories</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/supply-brands']" class=""
                      routerLinkActive="router-active">
                      <span class="span">Supply brands</span>
                    </a>
                  </li>

                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/price-units']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>sell</mat-icon> -->
                      <span class="span">Price Units</span>
                    </a>
                  </li>
                </ul>
              </li>
              <!-- directory -->
              <li>
                <a (click)="toggleDirectoryMenu()">
                  <mat-icon>folder_open</mat-icon>
                  <span>Directory</span>
                  <mat-icon *ngIf="isDirectoryMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isDirectoryMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isDirectoryMenu" class="">
                  <li>
                    <a *ngIf="['ADMIN'].includes(loginData?.type)"
                      [routerLink]="['/profile/directory/dir-listing']" routerLinkActive="router-active">
                      <span class="span">Add Directory</span>
                    </a>
                  </li>
                  <!-- <li>
                    <a *ngIf="!['ADMIN'].includes(loginData?.type)" (click)="toggleJobsDropdownClose()"
                      [routerLink]="['/profile/directory']" routerLinkActive="router-active">
                      <mat-icon>folder_open</mat-icon>
                      <span class="span">My Directories</span>
                    </a>
                  </li> -->
                  <li>
                    <a [routerLink]="['/profile/directory-categories']" routerLinkActive="router-active">
                      <!-- <mat-icon>category</mat-icon> -->
                      <span class="span">Directory Categories</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/profile/directory-business-types']" routerLinkActive="router-active">
                      <!-- <mat-icon>storefront</mat-icon> -->
                      <span class="span">Directory Business Types</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- banner -->
              <li>
                <a (click)="toggleBannersMenu()">
                  <div class="icon-stack">
                    <mat-icon>insert_photo</mat-icon>
                  </div>
                  <span>Banners</span>
                  <mat-icon *ngIf="isBannerMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isBannerMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isBannerMenu" class="">
                  <li>
                    <a [routerLink]="['/profile/banners/banner-list']" class="noIconMenu"
                      routerLinkActive="router-active">
                      <span>Banners</span>
                    </a>
                  </li>

                  <li>
                    <a [routerLink]="['/profile/banners/banner-category-list']" class="noIconMenu"
                      routerLinkActive="router-active">
                      <span>Banner Category</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- Job corner -->

              <li>
                <a (click)="toggleJobcornerMenu()" [routerLink]="['/profile/job-listing']">
                  <div class="icon-stack">
                    <mat-icon class="outer-icon">search</mat-icon>
                    <mat-icon class="inner-icon">work</mat-icon>
                  </div>
                  <span>Job Seek</span>
                  <mat-icon *ngIf="isJobcornermenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isJobcornermenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isJobcornermenu" class="">
                  <li>
                    <a [routerLink]="['/profile/job-listing']" routerLinkActive="router-active">
                      <!-- <mat-icon>task_alt</mat-icon> -->
                      <span class="span">Job Approval</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/profile/talent-listing']" routerLinkActive="router-active">
                      <!-- <mat-icon>flag</mat-icon> -->
                      <span class="span">Talent Approval</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/profile/job-role-listing']" routerLinkActive="router-active">
                      <!-- <mat-icon>supervisor_account</mat-icon> -->
                      <span class="span">Role</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/profile/list-employee-type']" routerLinkActive="router-active">
                      <!-- <mat-icon>schedule</mat-icon> -->
                      <span class="span">Employee type</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- My Used Supplies Supplies -->
              <li>
                <a (click)="toggleUsedSuppliesMenu()">
                  <mat-icon>inventory_2</mat-icon>
                  <span>Used Supplies</span>
                  <mat-icon *ngIf="isUsedSuppliesMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isUsedSuppliesMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isUsedSuppliesMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/pre-owned-supplies']"
                      class="noIconMenu" routerLinkActive="router-active">
                      <span class="">Used Supplies</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/my-bids']" class="noIconMenu"
                      routerLinkActive="router-active">
                      <span class="">My Bids</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- Miscellaneous -->
              <li>
                <a (click)="toggleMiscMenu()">
                  <mat-icon>widgets</mat-icon>
                  <span>Miscellaneous</span>
                  <mat-icon *ngIf="isMiscMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isMiscMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isMiscMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/states']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>public</mat-icon> -->
                      <span class="span">States</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/suburbans']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>location_city</mat-icon> -->
                      <span class="span">Suburbs</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/broadcasts']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>campaign</mat-icon> -->
                      <span class="span">Broadcasts</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/address']"
                      routerLinkActive="router-active">
                      <!-- <mat-icon>pin_drop</mat-icon> -->
                      <span class="span">My Address</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- Support -->
              <li>
                <a (click)="toggleSupportMenu()">
                  <mat-icon>support_agent</mat-icon>
                  <span>Support</span>
                  <mat-icon *ngIf="isSupportMenu" style="margin-left: auto">expand_less</mat-icon>
                  <mat-icon *ngIf="!isSupportMenu" style="margin-left: auto">expand_more</mat-icon>
                </a>
                <ul *ngIf="isSupportMenu" class="">
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/support-management']"
                      class="noIconMenu" routerLinkActive="router-active">
                      <span>Support Requests</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/support-request-reasons']"
                      class="noIconMenu" routerLinkActive="router-active">
                      <span>Support request reasons</span>
                    </a>
                  </li>
                  <li>
                    <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/support-center']" class="noIconMenu"
                      routerLinkActive="router-active">
                      <span>Support Center</span>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- My Enquiries -->
              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/enquiries']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>My Enquiries</span>
                </a>
              </li>

              <!-- Memberships -->
              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/membership']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>My Subscriptions</span>
                </a>
              </li>

              <!-- coupons -->
              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/coupons']"
                  routerLinkActive="router-active">
                  <mat-icon>confirmation_number</mat-icon>
                  <span> My Coupons</span>
                </a>
              </li>

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/catalogues']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>Catalogues</span>
                </a>
              </li> -->

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/price-units']"
                  routerLinkActive="router-active">
                  <mat-icon>sell</mat-icon><span>Price Units</span>
                </a>
              </li> -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/supply-categories']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>Supply category</span>
                </a>
              </li> -->

              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/clients']"
                  routerLinkActive="router-active">
                  <mat-icon>group</mat-icon><span>Clients</span>
                </a>
              </li>

                     <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/admin']"
                  routerLinkActive="router-active">
                  <mat-icon>manage_accounts</mat-icon><span>Admin</span>
                </a>
              </li>
              <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/subscription-plans']"
                  routerLinkActive="router-active">
                  <mat-icon>receipt_long</mat-icon><span>Subscription Plans</span>
                </a>
              </li>

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/directory-business-types']"
                  routerLinkActive="router-active">
                  <mat-icon>storefront</mat-icon><span>Directory business types</span>
                </a>
              </li> -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/directory-categories']"
                  class="noIconMenu" routerLinkActive="router-active">
                  <span>Directory categories</span>
                </a>
              </li> -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/catalogue-categories']"
                  class="noIconMenu" routerLinkActive="router-active">
                  <span>Catalogue Categories</span>
                </a>
              </li> -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/dental-supplier-supply-settings']"
                  class="noIconMenu" routerLinkActive="router-active">
                  <span>Supply Settings</span>
                </a>
              </li> -->

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/states']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>States</span>
                </a>
              </li> -->

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/suburbans']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>Suburbs</span>
                </a>
              </li> -->
              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/broadcasts']" class="noIconMenu"
                  routerLinkActive="router-active">
                  <span>Broadcasts</span>
                </a>
              </li> -->

              <!-- <li>
                <a (click)="toggleJobsDropdownClose()" [routerLink]="['/profile/account-pay']"
                  routerLinkActive="router-active">
                  <mat-icon>account_balance_wallet</mat-icon><span>Account Pay</span>
                </a>
              </li> -->
              <!-- Logout -->
              <li *ngIf="loginData" (click)="logout()">
                <a *ngIf="loginData" (click)="logout()">
                  <mat-icon>logout</mat-icon><span>Logout</span>
                </a>
              </li>
            </ul>
            <!--Admin menu start-->

            <ul class="profile_list_ul" style="display: none">
              <!-- My Dashboard -->
              <!--   <li>
                <a [routerLink]="['/dashboard']" routerLinkActive="router-active">
                  <mat-icon>dashboard</mat-icon><span>Old Dashboard</span>
                </a>
              </li> -->
              <!-- My Dashboard -->
              <li>
                <a [routerLink]="['/profile/my-dashboard']" routerLinkActive="router-active">
                  <mat-icon>dashboard</mat-icon><span>My Dashboard</span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/profile/detail']" [routerLinkActiveOptions]="{ exact: true }"
                  routerLinkActive="router-active">
                  <mat-icon>account_circle</mat-icon><span>View Profile</span>
                </a>
              </li>
              <!--<li *ngIf="['ADMIN','SUPPLIER','PRACTICE', 'PROFESSIONAL'].includes(loginData?.type)">
                <a [routerLink]="['/profile/reports']" routerLinkActive="router-active"
                  routerLinkActive="router-active"><mat-icon>play_arrow</mat-icon>My Reports </a>
              </li>
              -->
              <!-- My Pre-Owned Supplies -->
              <li *ngIf="
                  ['ADMIN', 'SUPPLIER', 'PRACTICE', 'PROFESSIONAL'].includes(
                    loginData?.type
                  )
                ">
                <a [routerLink]="['/profile/pre-owned-supplies']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon>
                  <span>My Pre-Owned Supplies</span>
                </a>
              </li>
              <!-- My pre owned Orders -->
              <li *ngIf="secondhand == true">
                <a [routerLink]="['/profile/my-pre-owned-orders']" routerLinkActive="router-active">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; My pre owned
                    orders</span>
                </a>
              </li>
              <!-- My Bids -->
              <li>
                <a [routerLink]="['/profile/my-bids']" routerLinkActive="router-active">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; My Bids</span>
                </a>
              </li>
              <li *ngIf="secondhand == true">
                <a [routerLink]="['/profile/pre-owned-orders/list']" routerLinkActive="router-active">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pre owned
                    order</span>
                </a>
              </li>
              <!-- My Orders -->
              <li>
                <a [routerLink]="['/profile/orders']" routerLinkActive="router-active">
                  <mat-icon>description</mat-icon><span>Orders</span>
                </a>
              </li>
              <li *ngIf="['SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/account-pay-requests']" routerLinkActive="router-active">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Account Pay
                    Requests</span>
                </a>
              </li>

              <!-- My Enquiries -->
              <li>
                <a [routerLink]="['/profile/enquiries']" routerLinkActive="router-active">
                  <mat-icon> message</mat-icon><span>My Enquiries</span>
                </a>
              </li>
              <!-- enquiries -->
              <li *ngIf="['SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/enquiries-management']" routerLinkActive="router-active">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enquiries</span>
                </a>
              </li>
              <!-- My Address -->
              <li>
                <a [routerLink]="['/profile/address']" routerLinkActive="router-active">
                  <mat-icon> pin_drop</mat-icon><span>My Address</span>
                </a>
              </li>
              <!-- Memberships -->
              <li>
                <a [routerLink]="['/profile/membership']" routerLinkActive="router-active">
                  <mat-icon>card_membership</mat-icon><span>My Subscriptions</span>
                </a>
              </li>
              <!-- My favourites -->
              <li>
                <a [routerLink]="['/profile/favourites']" routerLinkActive="router-active">
                  <mat-icon>favorite</mat-icon><span>My Favourites</span>
                </a>
              </li>

              <li *ngIf="['ADMIN', 'SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/support-management']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Support Requests</span>
                </a>
              </li>
              <!-- Support Center -->
              <li [routerLink]="['/profile/support-center']" routerLinkActive="router-active">
                <a>
                  <mat-icon>headset_mic</mat-icon><span>Support Center</span>
                </a>
              </li>

              <!-- My supplies -->
              <li *ngIf="['ADMIN', 'SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/supplies']" routerLinkActive="router-active">
                  <mat-icon>how_to_vote</mat-icon>
                  <span>My Supplies</span>
                </a>
              </li>

              <!-- coupons -->
              <li *ngIf="['ADMIN', 'SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/coupons']" routerLinkActive="router-active">
                  <mat-icon>confirmation_number</mat-icon>
                  <span> My Coupons</span>
                </a>
              </li>
              <!-- supply-deals -->
              <li *ngIf="['SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/supply-deals']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>My Supply Deals</span>
                </a>
              </li>
              <!-- catalogues -->
              <li *ngIf="['ADMIN', 'SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/catalogues']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>My Catalogues</span>
                </a>
              </li>

              <li *ngIf="['SUPPLIER'].includes(loginData?.type)">
                <a [routerLink]="['/profile/freight-ranges']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Freight Ranges</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/price-units']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Price Units</span>
                </a>
              </li>
              <!-- <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/supply-categories']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Supply category</span>
                </a>
              </li> -->
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/supply-sub-categories']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Supply sub categories</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/supply-brands']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Supply brands</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/clients']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Clients</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/subscription-plans']" routerLinkActive="router-active">Subscription
                  <mat-icon>play_arrow</mat-icon><span>plans</span>
                </a>
              </li>

              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/directory-business-types']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Directory business types</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/directory-categories']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Directory categories</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/catalogue-categories']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Catalogue Categories</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/dental-supplier-supply-settings']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Supply Settings</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/support-request-reasons']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Support request reasons</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/states']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>States</span>
                </a>
              </li>

              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/suburbans']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Suburbs</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/broadcasts']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Broadcasts</span>
                </a>
              </li>
              <li *ngIf="['ADMIN'].includes(loginData?.type)">
                <a [routerLink]="['/profile/banners']" routerLinkActive="router-active">
                  <mat-icon>play_arrow</mat-icon><span>Banners</span>
                </a>
              </li>

              <!-- Registered Courses -->
              <!--<li>
                <a>
                  <img src="../../../../../assets/images/profile/icons/8.png" alt="" class="icon">
                  <span>Registered Courses</span>
                </a>
              </li>-->
              <!-- Notifications & Reminders -->
              <!--<li>
                <a>
                  <img src="../../../../../assets/images/profile/icons/9.png" alt="" class="icon">
                  <span>Notifications & Reminders</span>
                </a>
              </li>-->
              <!-- Support Center -->
              <li [routerLink]="['/profile/support-center']" routerLinkActive="router-active">
                <a>
                  <mat-icon>headset_mic</mat-icon><span>Support Center</span>
                </a>
              </li>
              <!-- Support Center -->
              <li [routerLink]="['/profile/account-pay']" routerLinkActive="router-active">
                <a>
                  <mat-icon>account_balance_wallet</mat-icon><span>Account Pay</span>
                </a>
              </li>
              <!-- Logout -->
              <li *ngIf="loginData" (click)="logout()">
                <a> <mat-icon>logout</mat-icon><span>Logout</span> </a>
              </li>
              <!-- Memberships -->
            </ul>
          </div>


          <!--
          <div class="service_box pad-bgw">
            <h4 class="box_headingN">Service 3</h4>
            <img
              src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360/dental-test/7fdd21c4-ff06-4afd-a24b-eecfd765a0e6">
            <h6>Faucibus neque elit </h6>
            <p>Aenean non accumsan ante. Duis et risus accumsan sem tempus porta nec sit amet est.</p>
            <a href="#">Read more</a>
          </div>
          -->
        </div>
        <div class="addSection" style="margin-top: 20px">
          <div class="addSection" *ngIf="leftNavBannerData?.length" style="margin-top: 20px">
            <swiper [config]="leftNavBNSwiperConfig" class="banner-swiper">
              <div *ngFor="let banner of leftNavBannerData" swiperSlide #leftNavSlide>
                <div class="banner-wrapper">
                  <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                    <img class="banner-image" [src]="banner.img?.url" [alt]="banner.img.name" />
                  </a>
                </div>
              </div>

              <div class="swiper-pagination"></div>
            </swiper>
          </div>
        </div>

        <!-- Sticky banner container -->




      </div>
      <div class="profile_right_column" fxLayout="column" fxFlex="81" fxFlex.lg="76" fxFlex.md="76" fxFlex.sm="65"
        fxFlex.xs="100" fxFlexFill>
        <div class="master_profile_right_sec master_dashboard_router">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <div class="overlay-bottom"></div>
  </section>
</div>